import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import SalesDeck from "@/pages/SalesDeck";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/sales" element={<SalesDeck />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
